import axios from './axiosInstance';
import { Notification, NotificationResponse } from '../types/notificationTypes';
import { ApiResponse } from '../types/apiTypes';

export interface NotificationFilters {
  page?: number;
  limit?: number;
}

export interface CreateNotificationPayload {
  userId: string;
  title: string;
  message: string;
  type?: string;
  sendEmail?: boolean;
}

/**
 * Fetch a page of notifications for a user.
 * Returns ApiResponse with data and pagination metadata.
 */
export async function fetchNotifications(
  filters?: NotificationFilters
): Promise<NotificationResponse> {
  const response = await axios.get<NotificationResponse>(
    `/notification`,
    { params: filters }
  );
  return response.data;
}

/**
 * Create a new notification (optionally sending an email).
 * Returns ApiResponse wrapper of the created Notification.
 */
export async function createNotification(
  payload: CreateNotificationPayload
): Promise<ApiResponse<Notification>> {
  const response = await axios.post<ApiResponse<Notification>>(
    '/notification',
    payload
  );
  return response.data;
}

/**
 * Mark a single notification as read.
 * Returns ApiResponse wrapper of the updated Notification.
 */
export async function markNotificationAsRead(
  notificationId: string
): Promise<ApiResponse<Notification>> {
  const response = await axios.patch<ApiResponse<Notification>>(
    `/notification/${notificationId}/read`
  );
  return response.data;
}

/**
 * Mark all notifications as read for a user.
 * Returns ApiResponse with pagination updated (if any).
 */
export async function markAllNotificationsAsRead(
): Promise<ApiResponse<null>> {
  const response = await axios.patch<ApiResponse<null>>(
    `/notification/markAllRead`
  );
  return response.data;
}
